export default __webpack_public_path__ + "static/media/rightArrow.8c29f0de.svg";